(function (angular) {

    angular.module('app.purchase')
        .directive('planSelection', planSelectionDirective);

    function planSelectionDirective() {
        return {
            restrict: 'E',
            templateUrl: '/app/site/purchase-flow/choose-plan/plan-selection.html'
        };
    };

}(angular));
